// Ícone de magia do cliente (folha spell-icons-32x32 do Tibia).
import type { SpellDef } from '../../../../shared/src/game/spells';
import { SPELL_ICONS } from '../spells';

const GROUP_COLOR: Record<string, string> = { attack: '#7a2020', healing: '#1f4f7a', support: '#4f5f20' };

export function SpellIcon(props: { spell: SpellDef; size?: number; dim?: boolean }) {
  const size = props.size ?? 32;
  const s = props.spell;
  if (s.icon < 0) {
    return <span class="spell-icon fallback" style={{ width: size, height: size, background: GROUP_COLOR[s.group] ?? '#333' }}>{s.name.split(' ').map((w) => w[0]).join('').slice(0, 2)}</span>;
  }
  return (
    <span class={'spell-icon' + (props.dim ? ' dim' : '')} title={s.name}
      style={{ width: size, height: size, backgroundImage: `url(${SPELL_ICONS})`, backgroundPosition: `${-s.icon * size}px 0`, backgroundSize: `${201 * size}px ${size}px` }} />
  );
}
